import { Injectable } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { OkModalComponent } from '../generic-components/ok-modal/ok-modal.component';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthService } from '../guards/auth.service';
import { Title } from '@angular/platform-browser';
import { ImageModalComponent } from '../generic-components/image-modal/image-modal.component';
import { ApiService } from '../api.service';

@Injectable()
export class FunctionsService {
    constructor(
        private apiService: ApiService,
        private httpClient:HttpClient,
        private permission: NgxPermissionsService,
        private router: Router,
        private translate: TranslateService,
        private modalService: NgbModal,
        private authService: AuthService,
        private titleService: Title) {
        translate.setDefaultLang('en');
        this.modalService.dismissAll();
        this.modalOptions.backdrop = 'static';
        this.modalOptions.keyboard = false;
        this.modalOptions.size = 'lg';
    }
    
    modalOptions: NgbModalOptions = {};

    getCurrentYear(){
        return (new Date()).getFullYear();
    }
    formatDate(event){
        var birthDate = null;
        if(event.value){
          var sd = new Date(event.value);
          birthDate = (sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getFullYear();
        }
        return birthDate;
    }

    formatNotiDate(value){
        var notiDate = null;
        if(value){
          var sd = new Date(value);
          var month = ((sd.getMonth()+1)<10)?("0"+(sd.getMonth()+1)):sd.getMonth()+1;
          var date = ((sd.getDate())<10)?("0"+(sd.getDate())):sd.getDate();
          notiDate = sd.getFullYear()+"-"+month+"-"+date;
        }
        return notiDate;
    }

    HEXToIntColor(color) {
        var defaultColor = parseInt("0xC4C4C0", 16);
        color = parseInt(color.replace('#','0x'), 16);
        return (color <= defaultColor);
    }

    monthlyFilter(date){
        var currentDate = new Date();
        var startDate = new Date(date+"Z");
        var month = currentDate.getMonth()+1;
        var year = currentDate.getFullYear();
        var sm = startDate.getMonth()+1;
        var sy = startDate.getFullYear();
        var dropwdown = [];
        while((+new Date(sy,sm)) <= (+new Date(year,month))){
            if(month==0){
                year = year-1;
                month = 12;
            }
            dropwdown.push(month+"/"+year);
            month--;
        }
        
        return dropwdown;
    }

    yearlyFilter(date){
        var currentDate = new Date();
        var startDate = new Date(date+"Z");
        var year = currentDate.getFullYear();
        var sy = startDate.getFullYear();
        var dropwdown = [];
        while(sy <= year){
            dropwdown.push(year);
            year--;
        }
        return dropwdown;
    }

    convertUTCDateToLocalDateMessage(d){
        var newDate = new Date(d);

        let date = (newDate.getMonth()+1)+"/"+newDate.getDate()+"/"+newDate.getFullYear();
        if(localStorage.getItem('language') != null && localStorage.getItem('language')=="es"){
            date = newDate.getDate()+"/"+(newDate.getMonth()+1)+"/"+newDate.getFullYear();
        }
        let time = newDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
        return date + " " + time;  
    };

    convertUTCDateToLocalDateUS(d, hour12 = true){
        var newDate = new Date(d+"Z");

        var offset = newDate.getTimezoneOffset() / 60;
        var hours = newDate.getHours();

        newDate.setHours(hours - offset);
        let date = (newDate.getMonth()+1)+"/"+newDate.getDate()+"/"+newDate.getFullYear();
        let time = newDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: hour12 });
        return date + " " + time; 
    }

    convertUTCDateToLocalDate(d, hour12 = true){
        var newDate = new Date(d+"Z");
        var offset = newDate.getTimezoneOffset() / 60;
        var hours = newDate.getHours();

        //newDate.setHours(hours - offset);
        let date = (newDate.getMonth()+1)+"/"+newDate.getDate()+"/"+newDate.getFullYear();
        if(localStorage.getItem('language') != null && localStorage.getItem('language')=="es"){
            date = newDate.getDate()+"/"+(newDate.getMonth()+1)+"/"+newDate.getFullYear();
        }
        let time = newDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: hour12 });
        return date + " " + time;  
    };

    convertUTCDateToLocalDateOnly(d){
        var newDate = new Date(d+"Z");
        var offset = newDate.getTimezoneOffset() / 60;
        var hours = newDate.getHours();

        //newDate.setHours(hours - offset);
        let date = (newDate.getMonth()+1)+"/"+newDate.getDate()+"/"+newDate.getFullYear();
        if(localStorage.getItem('language') != null && localStorage.getItem('language')=="es"){
            date = newDate.getDate()+"/"+(newDate.getMonth()+1)+"/"+newDate.getFullYear();
        }
        return date;  
    };

    useLanguageRed(language: string) {
        const es = document.getElementById('es');
        const en = document.getElementById('en');
        localStorage.setItem('language', language);
        this.translate.use(language);
        if((es!=null) && (en!=null)){
            if (language === 'es') {
                es.style.fontWeight = 'bolder';
                en.style.fontWeight = 'normal';
            } else {
                es.style.fontWeight = 'normal';
                en.style.fontWeight = 'bolder';
            }
        }
    }

    useLanguage(language: string) {
        const es = document.getElementById('es');
        const en = document.getElementById('en');
        localStorage.setItem('language', language);
        this.translate.use(language);
        if(es && en){
            if (language === 'es') {
                es.style.fontWeight = 'bolder';
                en.style.fontWeight = 'normal';
            } else {
                es.style.fontWeight = 'normal';
                en.style.fontWeight = 'bolder';
            }
        }
    }

    checkZipCode(zipCode){
        if((zipCode>=600 && zipCode<=799) || (zipCode>=900 && zipCode<=999)){
            return true;
        }
        return false;
    }

    errorHandler(error){
        if(localStorage.getItem('language') != null){
            this.useLanguage(localStorage.getItem('language'));
        }
        switch(error){
            case 400:
                var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
                modalRef.componentInstance.title = this.translate.instant('Error');
                modalRef.componentInstance.message = this.translate.instant('general.incomplete_action');
                break;
            case 401:
                var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
                modalRef.componentInstance.title = "Error";
                modalRef.componentInstance.message = this.translate.instant("general.unauthorized_user");
                modalRef.result.then(() => {
                    this.modalService.dismissAll();
                });  
                break;
            case 403:
                /*var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
                modalRef.componentInstance.title = this.translate.instant('Error');
                modalRef.componentInstance.message = this.translate.instant('general.permission_denied');*/
                break;
            case 500:
                this.modalService.dismissAll();
                this.signOut();
                break;
            case 501:
                var modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
                modalRef.componentInstance.title = this.translate.instant('Error');
                modalRef.componentInstance.message = this.translate.instant('general.incomplete_action');

                modalRef.result.then(() => {
                    this.modalService.dismissAll();
                });
                break;
            default:
                break;
        }
    }

    formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3]
        }
        return null
    }

    formatGroupName(name) {
        var splitName = name.split('#');
        return splitName[0];
    }

    formatMultiGroupName(name) {
        var roles = ["All","User","Admin","SecurityAgent","Supervisor"];
        var splitName = name.split(',');
        var list = "";
        splitName.forEach(element => {
            if(roles.includes(element)){
                list = list + this.translate.instant(element) + ", ";
            }else {
                list = list + element + ", ";
            }
        });
        list = list.slice(0, -2); 
        return list;
    }

    hourDropDown(MinuteInterval) {
        var hours = [];
        var n, i, g, r, S, l;
        n = 0, i = 0, r = 0, S = 0, g = 0, l = "AM";
        hours.push({"value":"00:00:00","name":"12:00 AM"});
        for (var e = 1; e < 60 / MinuteInterval * 24; e++) {
            60 == (i += MinuteInterval) && (g = n += 1, n >= 12 && (l = "PM"), i = 0), r = n > 12 ? n - 12 : n, 0 == n && (r = 12), 1 == n.toString().length && (g = "0" + n.toString(), g = "0" + n.toString()), 1 == r.toString().length && (r = "0" + r.toString()), S = 1 == i.toString().length ? "0" + i.toString() : i, hours.push({"value": (g.toString() + ":" + S.toString() + ":00"),"name":(r.toString() + ":" + S.toString() + " " + l)});
        }
        return hours;
    }

    getEmail() {
        return localStorage.getItem('email');
    }

   getOrg() {
        return localStorage.getItem('orgId');
    }

    getRole() {
        return localStorage.getItem('role');
    }

    getUserId() {
        return localStorage.getItem('userId');
    }

    isExpired() {
        return localStorage.getItem('Expired') == '1';
    }

    getCardLogo(type) {
        var card = "";
        switch(type){
            case "Visa":
                card = "fa fa-cc-visa";
                break;
            case "MasterCard":
                card = "fa fa-cc-mastercard";
                break;
            case "Discover":
                card = "fa fa-cc-discover";
                break;
            case "American Express":
                card = "fa fa-cc-amex";
                break;
            case "JCB":
                card = "fa fa-cc-jcb";
                break;
            default:
                card = "fa fa-credit-card";
        }
        return card;
    }

    currencyFormat(num) {
        num = (Math.round( num * 100 ) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return num;
    }

    previewPDF(url): any {
        return this.httpClient.get(url, { responseType: 'blob'}).pipe(
            map( res => {
                return new Blob([res], { type: 'application/pdf', });
            })
        );
      }

    previewMedia(url): any {
        return this.httpClient.get(url, { responseType: 'blob'}).pipe(
            map( res => {
                return new Blob([res], { type: 'video/x-matroska', });
            })
        );
    }

    viewExternal(link){
        window.open(link, '_blank', 'noopener');
    }

    codeToString(code){
        return String.fromCodePoint(code);
    }

    signOut(){
        var language = localStorage.getItem("language");
        this.authService.logout();
        localStorage.clear();
        this.permission.flushPermissions();
        localStorage.setItem('language', language);
        this.router.navigateByUrl('/login');
    }

    userSignOut(){
        var language = localStorage.getItem("language");
        this.authService.logout();
        localStorage.clear();
        localStorage.setItem('signOut', '1');
        this.permission.flushPermissions();
        localStorage.setItem('language', language);
        this.router.navigateByUrl('/login'); 
    }

    setTitle(title){
        this.titleService.setTitle(this.translate.instant(title) + " | Contigo MSJ");
        this.translate.onLangChange.subscribe(() => { 
            this.titleService.setTitle(this.translate.instant(title) + " | Contigo MSJ");
        });
    }

    openImage(link){
        const modalRef = this.modalService.open(ImageModalComponent, { size: 'lg' });
        modalRef.componentInstance.link = link;
    }

    remainingDays(currentDate,endDate){
        var remaining = (endDate.getTime() - currentDate.getTime());
        var remaining_days =  Math.ceil(remaining / (1000 * 3600 * 24));
        remaining_days = remaining_days>0?remaining_days:0;
        return remaining_days;
    }

        resizeImage(file:File, maxWidth:number, maxHeight:number):Promise<Blob> {
        return new Promise((resolve, reject) => {
            let image = new Image();
            image.src = URL.createObjectURL(file);
            image.onload = () => {
                let width = image.width;
                let height = image.height;
                
                if (width <= maxWidth && height <= maxHeight) {
                    resolve(file);
                }
    
                let newWidth;
                let newHeight;
    
                if (width > height) {
                    newHeight = height * (maxWidth / width);
                    newWidth = maxWidth;
                } else {
                    newWidth = width * (maxHeight / height);
                    newHeight = maxHeight;
                }
    
                let canvas = document.createElement('canvas');
                canvas.width = newWidth;
                canvas.height = newHeight;
    
                let context = canvas.getContext('2d');
    
                context.drawImage(image, 0, 0, newWidth, newHeight);
    
                canvas.toBlob(resolve, file.type);
            };
            image.onerror = reject;
        });
    }
}